export const formatHours = (time) => {
  if (!time) return "";

  const parts = time.split(":");

  const hours = parts[0] || "00";
  const minutes = parts[1] || "00";

  return `${hours}h ${minutes}m`;
};